<template>
  <v-row style="height: auto">
    <v-col cols="12" md="9" lg="10" class="p-0">
      <div id="report-container"></div>
    </v-col>
    <v-col cols="12" md="3" lg="2">
      <div class="nav-buttons">
        <v-btn v-for="(button, index) in navigationButtons"
               :key="index"
               color="primary"
               class="mb-3"
               @click="navigateToPage(button.targetPage)">
          {{ button.displayName }}
        </v-btn>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop, Watch } from 'vue-property-decorator';
import { Components } from '@core/helpers/decorators';
import * as pbi from 'powerbi-client';

@Component
@Components({})
export default class PowerBIReport extends Vue {
  @Prop({ default: null }) powerBiParams;

  config = null;

  report = null;

  navigationButtons = [];

  initializePowerBiEmbed() {
    const powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
    const reportContainer = document.getElementById('report-container');
    this.report = powerbi.embed(reportContainer, this.config);

    this.report.off('loaded');
    this.report.on('loaded', async () => {
      this.navigationButtons = await this.generateNavigationButtons();
    });

    this.report.off('rendered');
    this.report.on('rendered', async () => {
      this.navigationButtons = await this.generateNavigationButtons();
    });

    this.report.off('error');
    this.report.on('error', () => {
      console.error('Report error');
    });
  }

  get deviceType() {
    const platform = navigator.platform.toLowerCase();
    if (/(android|webos|iphone|ipad|ipod|blackberry|windows phone)/.test(platform)) {
      return 'mobile';
    } if (/mac|win|linux/i.test(platform)) {
      return 'desktop';
    } if (/tablet|ipad/i.test(platform)) {
      return 'tablet';
    }
    return 'unknown';
  }

  async generateNavigationButtons() {
    const navigationButtons = [];
    const pages = await this.report.getPages();

    pages.forEach((page) => {
      if (page.visibility === 0) {
        const { displayName } = page;
        const targetPage = page.name;
        navigationButtons.push({ displayName, targetPage });
      }
    });

    return navigationButtons;
  }

  navigateToPage(targetPage) {
    this.report.setPage(targetPage);
  }

  @Watch('powerBiParams')
  async onPowerBiParamsChange(newPowerBiParams) {
    if (newPowerBiParams) {
      this.config = {
        type: 'report',
        tokenType: pbi.models.TokenType.Embed,
        accessToken: newPowerBiParams.accessToken,
        embedUrl: newPowerBiParams.reportConfig.embedUrl,
        id: newPowerBiParams.reportConfig.reportId,
        permissions: pbi.models.Permissions.Read,
        viewMode: pbi.models.ViewMode.View,
        settings: {
          panes: {
            filters: { expanded: false, visible: false },
            pageNavigation: { visible: false }
          },
          layoutType: this.deviceType === 'mobile' ? pbi.models.LayoutType.MobilePortrait : pbi.models.LayoutType.Custom,
          customLayout: {
            displayOption: pbi.models.DisplayOption.FitToWidth,
            ReportAlignment: pbi.models.ReportAlignment.Center
          }
        }
      };
      this.initializePowerBiEmbed();
    }
  }
}
</script>

<style>
#report-container {
  margin-left: 40px;
  height: 800px;
}

.nav-buttons {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  padding-top: 60px;
  padding-left: 1rem;
}

.nav-buttons > .v-btn {
  height: auto;
  min-height: 50px;
  width: 100%;
  margin-bottom: 10px;
  border-radius: 5px;
  font-weight: bold;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

iframe {
  border: none;
}

</style>
